import ManagementOption from "../../components/ManagementOption";
import { visibleManagementOptions } from "./managementOptions";

interface ManagementProps {
  allowedRoutes?: string[];
}

const Management = (props: ManagementProps) => {
  const options = visibleManagementOptions(props.allowedRoutes);

  return (
    <div>
      {/* This is the global column search box */}
      <div className="grid__title__container">
        <div className="grid__header__background">
          <div className="grid__title">
            <div style={{ color: "white", padding: "1rem 0 1rem 0" }}>
              Management
              <p>Manage user accounts and permissions</p>
            </div>
          </div>
        </div>
      </div>

      <div className="management__menu__container">
        {options.length === 0 && (
          <p>You don't have access to any management options.</p>
        )}
        {options.map((option) => (
          <div className="management__row__item" key={option.to}>
            <ManagementOption
              onTitle={option.title}
              onSubTitle={option.subTitle}
              onNavigation={option.to}
              onIcon={option.icon}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Management;
